//new 31/7/26//

import React from "react";
import RoomCard from "./RoomCard";

const rooms = [
  {
    id: 1,
    roomType: "Deluxe Room",
    roomNumber: 101,
    capacity: 4,
    price: 1500,
    image: "/images/room1.jpg",
  },
  {
    id: 2,
    roomType: "Suite Room",
    roomNumber: 102,
    capacity: 4,
    price: 1500,
    image: "/images/room2.jpg",
  },
  {
    id: 3,
    roomType: "Family Room",
    roomNumber: 103,
    capacity: 4,
    price: 1500,
    image: "/images/room3.jpg",
  },
  {
    id: 4,
    roomType: "Single Room",
    roomNumber: 104,
    capacity: 4,
    price: 1500,
    image: "/images/room4.jpg",
  },
];

export default function RoomList() {
  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4 fw-bold">Available Rooms</h2>

      <div className="row">
        {rooms.map((room) => (
          <RoomCard key={room.id} room={room} />
        ))}
      </div>
    </div>
  );
}